import React, {useContext} from 'react'
import AppContext from "../../../common/context/app-context";

const ShowAddAllProductsToShopify = ({productsList}) => {
    const appContext = useContext(AppContext);
    let {addAllShopifyProducts} = appContext;

    return (
        <>
            <div className="flex justify-between">
                {productsList?.length > 0 &&
                    <button
                        onClick={() => {
                            addAllShopifyProducts(productsList)
                        }}
                        className="button-gray-outline py-2 px-3 mx-1 flex justify-center">
                        <span className="">Add All Products</span>
                    </button>
                }
            </div>

        </>
    )
}

export default ShowAddAllProductsToShopify
